import { ChartMultiBarModel } from "model/chart/ChartMultiBarModel";
import { VictoryAxis, VictoryBar, VictoryChart, VictoryGroup, VictoryTheme } from "victory";

type Props = {
    data: ChartMultiBarModel;
}
export default function AuditoriaNaoConformidadeChartBar(props: Props) {

    return (
        <div style={{ height: "55vh" }}>
            <VictoryChart
                theme={VictoryTheme.material}
                width={800}
                height={400}
                padding={{ top: 10, bottom: 30, left: 60, right: 0 }}
            >
                <VictoryGroup
                    offset={20}
                    style={{ data: { width: 15 } }}
                >
                    {props.data.multiBars.map((multiBar, index) => {
                        return <VictoryBar
                            colorScale={[multiBar.name == "Conforme" ? "#36A2EB" : "#FF6384"]}
                            data={multiBar.bars}
                            x={"name"}
                            y={"y"}
                            labels={({ datum }) =>
                                datum.y
                            }
                        />
                    })}
                </VictoryGroup>
            </VictoryChart>
        </div>
    );
}